import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
// @ts-ignore
import MobileStoreButton from '@r1-frontend/ui-react/components/buttons/mobileStoreButton/index';
import wideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RequestFormPhone } from '~/src/components/RequestFormPhone';

import { IImgParams } from './data';

export const ConnectDomofon = styled.div<{ hasDomofon: boolean, backgroundImg: string }>`
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    background-image: url('${p => p.backgroundImg}');
    background-repeat: no-repeat;
    background-position: right bottom -5px;
    background-size: 100% auto;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        background-size: auto 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        background-position: center bottom -5px;
        overflow: hidden;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        height: auto;
        padding-top: ${p => p.hasDomofon ? '60px' : '0'};
        padding-bottom: 30px;
        overflow: initial;
    }
`;

export const SWideContainer = styled(wideContainer)`
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const SRequestFormPhone = styled(RequestFormPhone)`
    label {
        color: ${COLORS.GRAY_DARK};

        a {
            color: ${COLORS.GRAY_DARK};
            border-bottom: 1px solid ${COLORS.GRAY_DARK};
        }
    }

    > div > div {
        > button {
           @media (max-width: ${wideBreakpoints.mobile}) {
               width: 100%;
            }
        }
    }
`;

export const Description = styled.div`
    position: relative;
    z-index: 1;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 50px 0;

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 50px 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        justify-content: flex-start;
    }
`;

export const Title = styled.div`
    margin-bottom: 6px;
    max-width: 660px;
    ${FONTS.H1};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H2};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }
`;

export const Text = styled.div<{hasDomofon?: boolean}>`
    margin-bottom: 32px;
    max-width: 660px;
    ${FONTS.XL};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.L};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
        ${p => p.hasDomofon ? css`${FONTS.M};` : ''};
    }
`;

export const ImgWrap = styled.div<{ hasDomofon: boolean }>`
    position: relative;
    align-items: flex-end;
    max-width: 623px;
    padding-left: 5%;

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-right: -20%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex: 0 0 440px;
        margin-right: 0;
        padding-left: 0;
        order: ${p => p.hasDomofon ? '1' : '-1'};
        max-width: none;
    }
`;

export const Img = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: absolute;
        max-height: 645px;
        width: auto;
        top: 0;
        right: 0;
    }
`;

export const VideoWrap = styled.div<{ hasDomofon: boolean }>`
    position: absolute;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    top: 206px;
    left: 135px;
    width: 177px;
    height: 155px;
    
    ${p => p.hasDomofon
        ? css`
            @media (max-width: ${wideBreakpoints.sDesktop}) {
                top: 268px;
                left: 109px;
                width: 144px;
                height: 126px;
            }
        
            @media (max-width: ${wideBreakpoints.laptop}) {
                top: 383px;
                left: 107px;
                width: 176px;
                height: 154px;
            }
        
            @media (max-width: ${wideBreakpoints.tablet}) {
                top: 423px;
                left: 92px;
                width: 162px;
                height: 141px;
            }
        
            @media (max-width: ${wideBreakpoints.mobile}) {
                top: 143px;
                left: auto;
                right: 75px;
                width: 140px;
                height: 123px;
            }
        `
        : css`
            top: 184px;
            left: 135px;
            width: 177px;
            height: 155px;

            @media (max-width: ${wideBreakpoints.sDesktop}) {
                top: 189px;
                left: 122px;
                width: 183px;
                height: 158px;
            }
        
            @media (max-width: ${wideBreakpoints.laptop}) {
                top: 155px;
                left: 98px;
                width: 149px;
                height: 131px;
            }
        
            @media (max-width: ${wideBreakpoints.tablet}) {
                top: 140px;
                left: 82px;
                width: 136px;
                height: 119px;
            }
        
            @media (max-width: ${wideBreakpoints.mobile}) {
                top: 143px;
                left: auto;
                right: 75px;
                width: 140px;
                height: 123px;
            }
        `
    }
`;

export const SVideo = styled.video<{ hasDomofon: boolean }>`
    width: 280px;

    ${p => p.hasDomofon
        ? css`
            @media (max-width: ${wideBreakpoints.sDesktop}) {
                width: 224px;
            }
        
            @media (max-width: ${wideBreakpoints.laptop}) {
                width: 275px;
            }
        
            @media (max-width: ${wideBreakpoints.tablet}) {
                width: 255px;
            }
        
            @media (max-width: ${wideBreakpoints.mobile}) {
                width: 220px;
            }
        `
        : css`
            @media (max-width: ${wideBreakpoints.laptop}) {
                width: 240px;
            }
        
            @media (max-width: ${wideBreakpoints.tablet}) {
                width: 215px;
            }
        
            @media (max-width: ${wideBreakpoints.mobile}) {
                width: 220px;
            }
        `
    }
`;

/* Стилизация для авторизованного */
export const TitleMin = styled.div`
    margin-bottom: 6px;
    max-width: 660px;
    ${FONTS.H2};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
    }
`;

export const SubTitle = styled.div`
    margin-bottom: 28px;
    max-width: 520px;
    ${FONTS.H2};

    & > i {
        ${FONTS.H1};
        color: ${COLORS.RED_FIRM};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 0;
        ${FONTS.H3};

        & > i {
            ${FONTS.H2};
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 285px;
        ${FONTS.H4};

        & > i {
            ${FONTS.H2};
        }
    }
`;

export const Steps = styled.div`
    flex-wrap: nowrap;
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex-direction: column;
    }
`;

export const StepWrap = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    margin-right: 32px;
    padding: 16px 16px 24px 16px;
    width: 352px;
    height: 259px;
    background-color: ${COLORS.white};
    border: 1px solid ${COLORS.GRAY_XS};
    border-radius: 16px;

    &:last-child {
        margin-right: 0;
        margin-bottom: 0;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-right: 24px;
        padding: 16px 16px 20px 16px;
        width: 343px;
        height: 279px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-right: 0;
        margin-bottom: 24px;
    }

    @media (max-width: 375px) {
        width: 100%;
    }
`;

export const FirstStepWrap = styled(StepWrap)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 343px;
        height: 211px;
    }

    @media (max-width: 375px) {
        width: 100%;
    }
`;

export const StepInner = styled.div`
    flex-wrap: nowrap;
`;

export const StepDescription = styled.div``;

export const StepTitle = styled.div`
    ${FONTS.H3};
    color: ${COLORS.RED_FIRM};
`;

export const StepText = styled.div`
    ${FONTS.H4};
    white-space: break-spaces;
`;

export const StepImgWrap = styled.div`
    margin-top: auto;
    width: 100%;
    justify-content: center;
`;

export const QRCodeWrap = styled.div`
    flex: 0 0 117px;
    width: 117px;
    height: 117px;

    & > img {
        width: inherit;
        height: inherit;
    }

    @media(max-width: ${wideBreakpoints.sDesktop}) {
        flex: 0 0 auto;
        width: 109px;
        height: 109px;
    }

    @media(max-width: ${wideBreakpoints.laptop}) {
        width: 88px;
        height: 88px;
    }
`;

export const StepBtns = styled.div`
    width: 100%;
    margin-top: auto;
    flex-wrap: nowrap;
    gap: 10px;
`;

export const SMobileStoreButton = styled(MobileStoreButton)`
    flex: 1;
    background-color: ${COLORS.GRAY_XS};
    border-radius: 12px;

    img {
        opacity: 1;
    }

    &:hover {
        opacity: 0.5;
        transition: 0.25s;
    }
`;

/* Анимированные картинки */
const getImgParams = (imgParams: IImgParams) => {
    let result = '';

    for (const key in imgParams) {
        result += `${key}:${imgParams[key as keyof IImgParams]};`;
    }

    return css`${result}`;
};

export const AnimImageWrap = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const AnimImage = styled.img<{
    params?: IImgParams,
    desktopParams?: IImgParams,
    laptopParams?: IImgParams,
    tabletParams?: IImgParams,
    mobileParams?: IImgParams,
    startPosition?: string,
}>`
    position: absolute;
    width: 75px;
    height: 75px;

    ${p => p.params ? getImgParams(p.params) : ''};

    @media (max-width: 1700px) {
        ${p => p.desktopParams ? getImgParams(p.desktopParams) : ''};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${p => p.laptopParams ? getImgParams(p.laptopParams) : ''};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${p => p.tabletParams ? getImgParams(p.tabletParams) : ''};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${p => p.mobileParams ? getImgParams(p.mobileParams) : ''};
    }

    ${p => p.startPosition};
    transition: all 1s ease-out;
`;
